export const config = {
    API_BASE_URL: window._env_?.API_BASE_URL || process.env.REACT_APP_API_URL || '',
    SOCKET_URL: window._env_?.SOCKET_URL || process.env.REACT_APP_SOCKET_URL || '',
    MAPBOX_TOKEN: window._env_?.MAPBOX_TOKEN || process.env.REACT_APP_MAPBOX_TOKEN || '',
    COPYRIGHT_TEXT: window._env_?.COPYRIGHT_TEXT || process.env.REACT_APP_COPYRIGHT_TEXT || '© 2024 WhatsApp Agent Chat. All rights reserved.',
    POWERED_BY: process.env.REACT_APP_POWERED_BY || 'Powered by WCloud Platform',
    // Add other environment variables here
};

// Use throughout your app
export const getMediaUrl = (url) => {
    if (!url) return '';
    return url.startsWith('http') ? url : `${config.API_BASE_URL}${url}`;
};